module.exports = __webpack_public_path__ + "img/chelsea-logo-icon.21599f8a.png";